module.exports = __webpack_public_path__ + "static/media/iconChatSmile.e00cfb12.svg";